import axios from "axios";
import { API_ENDPOINTS } from "../api-urls";


export const fetchAboutUsData = async () => {
  try {
    
    const aboutRes = await axios.get(API_ENDPOINTS.about);
    

    const aboutData = aboutRes.data?.data || null;

    let whyChooseUs = [];
    try {

      const whyChooseUsRes = await axios.get(API_ENDPOINTS.fetchWhyChooseUs);
      whyChooseUs = whyChooseUsRes.data?.data || [];
    } catch (whyChooseUsError) {
      console.warn("Failed to fetch 'Why Choose Us' data:", whyChooseUsError.response?.data || whyChooseUsError.message);
    }

    return { aboutData, whyChooseUs, error: null };
  } catch (error) {
    console.error("Error fetching About Us data:", error.response?.data || error.message);
    return {
      aboutData: null,
      whyChooseUs: [],
      error: error.response?.data?.message || "Failed to fetch data. Please try again.",
    };
  }
};
